import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobile, faGlobe, faRocket, faStar } from '@fortawesome/free-solid-svg-icons';
import { faApple, faGoogle } from '@fortawesome/free-brands-svg-icons';
import { useTranslation } from 'react-i18next';
import './App.css';

const logoUrl = process.env.PUBLIC_URL + '/logo.jpg';



function ComingSoon() {
  const { t } = useTranslation();
  const [timeLeft, setTimeLeft] = useState({});
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const launchDate = new Date("2025-07-20T19:00:00+02:00").getTime();

    const intervalId = setInterval(() => {
      const now = new Date().getTime();
      const distance = launchDate - now;

      if (distance < 0) {
        clearInterval(intervalId);
        setTimeLeft({ launch: true });
        return;
      }

      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds: Math.floor((distance % (1000 * 60)) / 1000)
      });
    }, 1000);

    // Animasyon için
    setTimeout(() => setIsVisible(true), 500);

    return () => clearInterval(intervalId);
  }, []);



  const renderCountdown = () => {
    if (timeLeft.launch) {
      return (
        <div className="launch-message">
          <FontAwesomeIcon icon={faRocket} className="launch-icon" />
          <h2>{t('countdown.launch')}</h2>
        </div>
      );
    }
    
    const timerComponents = [];
    const labels = {
      days: t('countdown.days'),
      hours: t('countdown.hours'),
      minutes: t('countdown.minutes'),
      seconds: t('countdown.seconds')
    };
    
    Object.keys(timeLeft).forEach(interval => {
      if (timeLeft[interval] === undefined) return;
      timerComponents.push(
        <div key={interval} className="countdown-item">
          <div className="countdown-value">{timeLeft[interval]}</div>
          <div className="countdown-label">{labels[interval]}</div>
        </div>
      );
    });
    return timerComponents.length ? timerComponents : <p>{t('countdown.loading')}</p>;
  }

  return (
    <div className="app-container" id="coming-soon-page">
      <div className={`content-box ${isVisible ? 'visible' : ''}`}>
        <div className="logo-section">
          <img src={logoUrl} alt="Utkan eSIM Logo" className="logo" />
          <div className="logo-glow"></div>
        </div>
        
        <h1 className="main-title">
          <span className="gradient-text">{t('hero.title')}</span>
          <br />
          <span className="subtitle">{t('hero.subtitle')}</span>
        </h1>
        
        <p className="hero-description">
          {t('hero.description')}
          <br />
          {t('hero.description2')}
        </p>

        <div className="features-grid">
          <div className="feature-item">
            <FontAwesomeIcon icon={faGlobe} className="feature-icon" />
            <span>{t('features.countries')}</span>
          </div>
          <div className="feature-item">
            <FontAwesomeIcon icon={faRocket} className="feature-icon" />
            <span>{t('features.activation')}</span>
          </div>
          <div className="feature-item">
            <FontAwesomeIcon icon={faStar} className="feature-icon" />
            <span>{t('features.support')}</span>
          </div>
        </div>

        <div className="countdown-section">
          <h3>{t('countdown.title')}</h3>
          <div className="countdown-container">
            {renderCountdown()}
          </div>
        </div>

        <div className="apps-section">
          <h3>{t('apps.title')}</h3>
          <div className="app-buttons">
            {/* Mağaza linkleri henüz yok; placeholder — yayınlanınca href doldurulacak. */}
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a href="#" className="app-button ios">
              <FontAwesomeIcon icon={faApple} />
              <div className="app-text">
                <span className="app-label">{t('apps.ios.label')}</span>
                <span className="app-name">{t('apps.ios.name')}</span>
              </div>
            </a>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a href="#" className="app-button android">
              <FontAwesomeIcon icon={faGoogle} />
              <div className="app-text">
                <span className="app-label">{t('apps.android.label')}</span>
                <span className="app-name">{t('apps.android.name')}</span>
              </div>
            </a>
          </div>
        </div>

        <div className="contact-section">
          <h3>{t('contact.title')}</h3>
          <div className="contact-info">
            <a href="https://wa.me/905401551333" target="_blank" rel="noopener noreferrer" className="contact-link whatsapp">
              <FontAwesomeIcon icon={faMobile} />
              <span>{t('contact.whatsapp')}</span>
            </a>
            <a href="mailto:info@utkanesim.com" className="contact-link email">
              <FontAwesomeIcon icon={faGlobe} />
              <span>{t('contact.email')}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ComingSoon;
